// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import SimpleSelect from './FormWidgets/SimpleSelect';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { capitalizeFirstLetter } from '../../infrastructure/utils/common';

const StyledWrapper = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
  display: flex;
  align-items: baseline;
  margin: 10px 20px;
  padding: 10px 20px !important;
  border: 1px solid #363636;

  h4 {
    font-size: 18px;
    margin-right: 15px;
  }
`;

const SelectWrapper = styled.div`
  width: 200px;
`;

const getSortOptionLabel = sort => {
  const nameLabel = sort.label || capitalizeFirstLetter(sort.name);
  let sortByLabel;
  if (sort.isString) {
    sortByLabel = sort.up ? 'A-Z' : 'Z-A';
  } else if (sort.isBoolean) {
    sortByLabel = sort.up ? 'No - Yes' : 'Yes - No';
  } else if (sort.isNumber) {
    sortByLabel = sort.up ? 'Asc' : 'Desc';
  } else {
    sortByLabel = sort.up ? 'Date Asc' : 'Date Desc';
  }
  return `${nameLabel} (${sortByLabel})`;
};

const MobileListSorter = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isSortSelected,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  activeSort,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  availableSort,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  changeSortBySelect,
}) => {
  if (!isSortSelected) return null;

  const onChange = json => {
    const { name, up } = JSON.parse(json);
    changeSortBySelect(name, up);
  };

  return (
    <StyledWrapper>
      <h4>Sort By</h4>
      <SelectWrapper>
        <SimpleSelect
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          className='select'
          onChange={onChange}
          value={JSON.stringify(activeSort)}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          data={availableSort.map(sort => ({
            label: getSortOptionLabel(sort),
            value: JSON.stringify(sort),
          }))}
        />
      </SelectWrapper>
    </StyledWrapper>
  );
};

export default MobileListSorter;
